var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mui-float-card",style:({width:this.width + 'px',height:this.height + 'px',top:this.styls2.top + 'px',left:this.styls2.left + 'px'}),on:{"mouseenter":_vm.mouseEnter,"mouseleave":_vm.mouseLeave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }